import Signal from '@signals/Signal.js';

export const spatialVisionDataChanged = new Signal();
export const spatialVisionRunCompleted = new Signal();
